const Theme = {
  logo_image_url: 'renaissance.png',
  header_background_color: '#504c1d',
  logo_height: 64,
  token_url: 'renaissance.png',
  token_width: 69,
  number_hidden: true,

  body_background_color: '#292f37',

  button_color: '#504c1d',
  button_radius: 2,
  button_half_border_color: '#292f37',

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

export default Theme
